import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: 'Bono 1',
    title: 'Los Grandes Reyes Vikingos',
    desc: 'Descubrí la historia y el legado de los líderes que marcaron el destino del mundo vikingo.'
  }, {
    num: 'Bono 2',
    title: 'Las Grandes Sagas Vikingas',
    desc: 'Conocé los relatos épicos que preservaron las hazañas de héroes, exploradores y guerreros del norte.'
  }, {
    num: 'Bono 3',
    title: 'Ragnarök: El Fin del Mundo Nórdico',
    desc: 'Explorá la gran profecía nórdica y el enfrentamiento final entre dioses, gigantes y criaturas legendarias.'
  }];
  return <section className="py-20 md:py-32 px-4 bg-dark-card/50" data-id="element-24">
      <div className="max-w-6xl mx-auto" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-26">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-27">
            <Gift className="w-8 h-8 text-gold" data-id="element-28" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white" data-id="element-29">
            Además recibís 3 bonos exclusivos
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-30">
          {bonuses.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark border border-dark-border rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-31">
              {/* Ribbon effect */}
              <div className="absolute top-0 right-0 w-24 h-24 overflow-hidden" data-id="element-32">
                <div className="absolute top-4 -right-8 w-32 bg-gold text-dark text-xs font-bold py-1 text-center rotate-45 shadow-md" data-id="element-33">
                  GRATIS
                </div>
              </div>

              <div className="text-gold-light font-bold text-sm tracking-widest mb-2 uppercase" data-id="element-34">
                {bono.num}
              </div>
              <h4 className="text-xl font-heading font-bold text-white mb-4 pr-8" data-id="element-35">
                {bono.title}
              </h4>
              <p className="text-gray-400 text-sm leading-relaxed mb-6 flex-grow" data-id="element-36">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}